import { FreeSpinsSyncFailure } from "@/v2/types/FreeSpinsSync/FreeSpinsSyncResult.interface";

import { GroupedFailure } from "../types/FreeSpinsRetrieval";

import { byGameCode } from "./byGameCode";

/** One row per game, currency and message, with every skin it failed on, A to Z. */
export const groupFailuresByGameAndReason = (
  failures: FreeSpinsSyncFailure[],
): GroupedFailure[] => {
  const groups = new Map<string, GroupedFailure>();
  failures.forEach(({ gameId, gameCode, currency, skinId, reason }) => {
    // Ids, codes and currencies have no `|`, so the key is unambiguous.
    const key = `${gameId}|${gameCode}|${currency}|${reason}`;
    const group = groups.get(key);
    if (!group) {
      groups.set(key, { gameId, gameCode, currency, reason, skinIds: [skinId] });
    } else if (!group.skinIds.includes(skinId)) {
      group.skinIds.push(skinId);
    }
  });
  return Array.from(groups.values()).sort(byGameCode);
};
